import { Flex, Text } from '@chakra-ui/react';
import { useMemo } from 'react';

import { SelectPlayTicketForm } from '~/components/play_tickets/SelectPlayTicketForm';
import { useI18nLn } from '~/hooks/store';
import { getGachaPaymentList } from '~/lib/utils/payment';
import { PaymentMethodVariables } from '~/types/payment';
import { PlayTicket } from '~/types/resources';
import { ApiPaymentMethod } from '~/types/resources/apiPaymentMethod';
import { GachaDetail } from '~/types/resources/gachaDetail';
import { GmoCredit } from '~/types/resources/gmo_credit';
import { PaymentForm } from '../orders/form/PaymentForm';
import { SelectPaymentDetail } from './SelectPaymentDetail';

type Props = {
  gachaDetail: GachaDetail;
  gachaPaymentMethods: ApiPaymentMethod[];
  payment_method: PaymentMethodVariables | null;
  setCardSeq: (cardSeq: string | null) => void;
  setPaymentMethod: (payment_method: PaymentMethodVariables) => void;
  credits: GmoCredit[];
  playTickets?: PlayTicket[];
  setPlayTicket: (playTicket: PlayTicket | null) => void;
  selectedPlayTicket: PlayTicket | null;
  loading: boolean;
  mutate: () => void;
};

/**
 * 支払い方法選択
 * クレジットカード支払いであればどのクレジットカードを使うかまでを選択できる
 */
export const SelectPaymentMethodContainer: React.FC<Props> = (props: Props) => {
  const { t, i18nLn } = useI18nLn();
  const availablePaymentMethods = useMemo(() => {
    const playTicketPaymentMethod: ApiPaymentMethod = {
      type: 'play_ticket',
      is_available:
        props.playTickets != undefined && props.playTickets.length > 0,
    };

    return getGachaPaymentList(
      [...props.gachaPaymentMethods, playTicketPaymentMethod],
      {
        lang: i18nLn ?? undefined,
      }
    );
  }, [i18nLn, props.gachaPaymentMethods, props.playTickets]);

  return (
    <Flex flexDir="column" w="full" gap={6}>
      <Text fontSize="16px" fontWeight="bold">
        {t('pages.buy.payments.title')}
      </Text>
      <PaymentForm
        payment_methods={availablePaymentMethods}
        selected_method={props.payment_method}
        onSelect={props.setPaymentMethod}
      />
      <SelectPaymentDetail
        payment_methods={availablePaymentMethods}
        payment_method={props.payment_method}
        setCardSeq={props.setCardSeq}
        setPaymentMethod={props.setPaymentMethod}
        credits={props.credits}
        loading={props.loading}
        mutate={props.mutate}
      />
      {props.payment_method == 'play_ticket' && (
        <SelectPlayTicketForm
          playTickets={props.playTickets ?? []}
          setPlayTicket={props.setPlayTicket}
          selectedPlayTicket={props.selectedPlayTicket}
        />
      )}
    </Flex>
  );
};
